// Turn a stored enum value into something readable: `before_after_split` →
// "Before after split". The vocabulary is snake_case everywhere (prompt,
// CI_ENUM_VALUES, filter values), and only the display layer differs.
export default function formatEnumLabel(value?: string | null): string {
  if (!value) return '';
  const spaced = value.replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
